import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs';

import { PublicBillSplitApiService } from '../../services/public-bill-split-api-service';
import { BillSplitSummaryResponseDto } from '@features/client/models/public-bill-split-models';
import { PublicBillSplitSummaryCardComponent } from '../../components/public-bill-split-summary-card/public-bill-split-summary-card';
import { PublicBillSplitFooterComponent } from '../../components/public-bill-split-footer/public-bill-split-footer';

@Component({
  selector: 'app-public-bill-split-shared-page',
  standalone: true,
  imports: [CommonModule, PublicBillSplitSummaryCardComponent, PublicBillSplitFooterComponent],
  templateUrl: './public-bill-split-shared-page.html',
})
export class PublicBillSplitSharedPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly api = inject(PublicBillSplitApiService);

  readonly loading = signal(true);
  readonly error = signal<string | null>(null);
  readonly summary = signal<BillSplitSummaryResponseDto | null>(null);

  constructor() {
    this.route.paramMap
      .pipe(
        switchMap((params) => {
          const splitId = params.get('splitId');

          if (!splitId) {
            throw new Error('No se recibió el identificador de la división.');
          }

          this.loading.set(true);
          this.error.set(null);

          return this.api.getSummary(splitId);
        }),
      )
      .subscribe({
        next: (summary) => {
          this.summary.set(summary);
          this.loading.set(false);
        },
        error: () => {
          this.error.set('No se pudo cargar la división compartida.');
          this.loading.set(false);
        },
      });
  }

  goToSplit(): void {
    this.router.navigate(['/divisor-cuenta']);
  }
}
